export const TWENTY_MIN_BY_MS = 60000 * 20;
export const randomMenus = [
  "스파게티",
  "탕수육",
  "피자",
  "치킨",
  "샌드위치",
  "햄버거",
  "라멘",
  "짬뽕",
  "짜장면",
  "순두부찌개",
  "소고기국밥",
  "콩나물국밥",
  "김치찌개",
  "부대찌개",
  "돈까스",
  "스테이크",
  "된장찌개",
  "뚝배기불고기",
  "떡볶이",
  "스시",
  "비빔밥",
  "베트남쌀국수",
  "족발보쌈",
  "김밥",
  "인도커리",
  "설렁탕",
  "육개장",
  "순대국밥",
  "우거지탕",
  "감자탕",
  "갈비탕",
  "모밀",
  "냉면",
];
